import MediaHandler, {
  MEDIA_TYPE,
  TYPE_IDENTIFIER,
} from '@/helpers/MediaHandler';
import Requests from '@/helpers/Request';
import { assembleUrl } from '@/mixins/queryAssembler';
import router from '@/router';
import device from './device';
import store from '@/store';

export const NAV_TYPE = {
  BACK: 'back',
  HOME: 'home',
};

const parseMainMenuItem = (item) => {
  const url = item.url;
  const lowerUrl = url.toLowerCase();
  console.log('==========================================================vod: url: ', url);
  // ZUERST: die Pruefungen darunter sind einfache Teilstring-Treffer, und eine
  // Browser-Url kann 'media' oder 'tv' enthalten (siehe navigation.js).
  if (lowerUrl.includes(TYPE_IDENTIFIER.BROWSER.toLowerCase())) {
    return {
      type: MEDIA_TYPE.BROWSER,
      url: MediaHandler.stripIdentifier(url, TYPE_IDENTIFIER.BROWSER),
    };
  }
  if (url.includes('iFrame')) {
    return {
      type: MEDIA_TYPE.WEBSITE,
      url: MediaHandler.assembleWebsiteQuery(item),
    };
  }
  if (url.includes('basicInfoApp')) {
    return {
      type: MEDIA_TYPE.IMAGE,
      url: MediaHandler.assembleBasicInfoAppImageQuery(item),
    };
  }
  if (lowerUrl.includes('submenu') || url.includes('SubMenu')) {
    return {
      type: MEDIA_TYPE.SUBMENU,
      url: MediaHandler.assembleSubMenuUrl(item),
    };
  }
  if (url.includes('tv')) {
    return {
      type: MEDIA_TYPE.TV,
      url: { name: 'TVPlayer' },
    };
  }
  if (url.includes('radio')) {
    return {
      type: MEDIA_TYPE.RADIO,
      url: { name: 'RadioPlayer' },
    };
  }
  if (url.includes('epg')) {
    return {
      type: MEDIA_TYPE.EPG,
      url: { name: 'EPGGuide' },
    };
  }
  if (url.includes('youtube')) {
    return {
      type: MEDIA_TYPE.YOUTUBE,
      url: { name: 'youtube' },
    };
  }
  if (url.includes('vod')) {
    return {
      type: MEDIA_TYPE.VOD,
      url: { name: 'Vod' },
    };
  }
  if (lowerUrl.includes('subvodmenu') || url.includes('SubVodMenu')) {
    return {
      type: MEDIA_TYPE.SUBVODMENU,
      url: MediaHandler.assembleSubVodMenuUrl(item),
    };
  }
  if (url.includes('welcome')) {
    return {
      type: MEDIA_TYPE.WELCOME,
      url: { name: 'Welcome' },
    };
  }
  if (url.includes(TYPE_IDENTIFIER.INPUT_SOURCE)) {
    return {
      type: MEDIA_TYPE.INPUT_SOURCE,
      url: { name: 'InputSource', params: item.config },
    };
  }
  console.log('ITEM: ', item);
  return {};
};

export default {
  namespaced: true,
  state: () => ({
    isLanguageSelected: false,
    isBackSelected: false,
    mainMenu: [],
    vodMenu: [],
    mainMenuSelectedItemIndex: 0,
    activeSubMenuId: '',
    subMenuMap: {
      vod: {
        lang: {
          en: {
            title: 'VoD',
          },
          de: {
            title: 'VoD',
          },
          ch_de: {
            title: 'VoD',
          },
          ch_it: {
            title: 'VoD',
          },
          ch_fr: {
            title: 'VoD',
          },
          fr: {
            title: 'VoD',
          },
          it: {
            title: 'VoD',
          },
          es: {
            title: 'VoD',
          },
          ru: {
            title: 'VoD',
          },
          tr: {
            title: 'VoD',
          },
          nl: {
            title: 'VoD',
          },
          ar: {
            title: 'VoD',
          },
          ko: {
            title: 'VoD',
          },
          el: {
            title: 'VoD',
          },
          pt: {
            title: 'VoD',
          },
          hu: {
            title: 'VoD',
          },
          da: {
            title: 'VoD',
          },
          sv: {
            title: 'VoD',
          },
        },
        items: [
          {
            lang: {
              en: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              de: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ch_de: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ch_it: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ch_fr: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              fr: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              it: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              es: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ru: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              tr: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              nl: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ar: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              ko: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              el: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              pt: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              hu: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              da: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
              sv: {
                title: 'VoD Stream',
                description: 'Test a VoD Channel',
              },
            },
            name: 'VoD Stream',
            type: 'video',
            position: 8,
            show: true,
            description: 'Test a VoD Channel',
            actionUrl: 'https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8',
          },
          {
            lang: {
              en: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              de: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ch_de: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ch_it: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ch_fr: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              fr: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              it: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              es: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ru: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              tr: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              nl: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ar: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              ko: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              el: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              pt: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              hu: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              da: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
              sv: {
                title: 'Video Bunny Test (1080p)',
                description: 'Demo of video content',
              },
            },
            name: 'Video Bunny Test (1080p)',
            description: 'Demo of video content.',
            thumbnail: process.env.HOST + '/static/img/bunny-poster.jpeg',
            //actionUrl: process.env.HOST + '/static/video/bunny.mp4',
            actionUrl: 'https://temp.digmedia.net/website/video/bigbuckbunnyclip.mp4',
            type: 'video',
            position: 11,
            show: true,
          },
          {
            lang: {
              en: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              de: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ch_de: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ch_it: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ch_fr: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              fr: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              it: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              es: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ru: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              tr: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              nl: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ar: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              ko: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              el: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              pt: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              hu: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              da: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
              sv: {
                title: 'Video Rain Test (720p)',
                description: 'Demo of video content',
              },
            },
            name: 'Video Rain Test (720p)',
            description: 'Demo of video content.',
            //actionUrl: process.env.HOST + '/static/video/rain-h264-720p.mp4',
            actionUrl: 'https://temp.digmedia.net/website/video/bigbuckbunnyclip.mp4',
            type: 'video',
            position: 12,
            show: true,
          },
          {
            lang: {
              en: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              de: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ch_de: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ch_it: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ch_fr: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              fr: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              it: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              es: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ru: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              tr: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              nl: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ar: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              ko: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              el: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              pt: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              hu: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              da: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
              sv: {
                title: 'Elephant Dream MP4',
                description: 'Demo of video content',
              },
            },
            name: 'Dream',
            description: 'Demo of video content.',
            actionUrl:
              'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
            type: 'video',
            position: 13,
            show: true,
          },
        ],
        currentIndex: 0,
        backgroundImage: process.env.HOST + '/static/img/ambient/bg.png',
      },
    },
    nextAction: undefined,
  }),
  mutations: {
    setFirstName(state, value = '') {
      state.firstname = value;
    },
    setLastName(state, value = '') {
      state.lastname = value;
    },
    setTitle(state, value = '') {
      state.title = value;
    },
    setSalutation(state, value = '') {
      state.salutation = value;
    },
    setSelectLanguage(state) {
      state.isLanguageSelected = !state.isLanguageSelected;
    },
    setSelectBack(state) {
      state.isBackSelected = !state.isBackSelected;
    },
    setSelectBackDefault(state) {
      state.isBackSelected = false;
    },
    setMainMenu(state, menu) {
      state.mainMenu = menu;
    },
    setVodMenu(state, menu) {
      //subMenuMap
      //vod
      //items
      //state.subMenuMap.vod.items = menu;
      state.vodMenu = menu;
    },
    setSubMenu(state, submenu) {
      console.log("============================================*************************=setSubMenu", submenu);
      const subObject = {};
      subObject[submenu.id] = submenu;
      state.subMenuMap = Object.assign({}, state.subMenuMap, subObject);
      console.log("=============================================setSubMenuSUB", state.subMenuMap);
      //if(state.subMenuMap[submenu.id]) {
      //} else {
      //  state.subMenuMap[submenu.id] = submenu;
      //}
    },
    resetSubMenuIndex(state, id) {
      state.subMenuMap[id].currentIndex = 0;
    },
    setMainMenuIndex(state, value = 0) {
      state.mainMenuSelectedItemIndex = value;
    },
    incMainMenuIndex(state) {
      state.mainMenuSelectedItemIndex++;
    },
    decMainMenuIndex(state) {
      state.mainMenuSelectedItemIndex--;
    },
    setSubMenuIndex(state, { id, value }) {
      state.subMenuMap[id] = Object.assign({}, state.subMenuMap[id], {
        currentIndex: value,
      });
      // state.subMenuMap[id].currentIndex = value;
    },
    setActiveSubMenuApp(state, value) {
      state.activeSubMenuId = value;
    },
    setNextAction(state, value = undefined) {
      state.nextAction = value;
    },
  },
  actions: {
    async init({ commit, dispatch, rootState }) {
      try {
        if (!rootState.buildingId) {
          await dispatch('device/init', null, { root: true });
        }

        /*
        const response = await Requests.get(
          `${process.env.API_PORTAL}/bid/${rootState.buildingId}/appmenu`
        );
        commit('setMainMenu', response);
        //dispatch('tv/prepare', null, { root: true });
        */

        const responseVod = await Requests.fetchVod({
          bid: rootState.buildingId,
        });
        //console.log('==========================RESPONSE init VOD', responseVod);

        const responseCat = await Requests.fetchVodCategory({
          bid: rootState.buildingId,
        });
        //console.log('==========================RESPONSE init VODCAT', responseCat);

        var videoList = responseVod.filter((elem) => {
          if(elem.active || elem.show) {
            return elem;
          } else {
            return false;
          }
        }).sort((a, b) => a.pos - b.pos);
        //console.log('==========================************************************RESPONSE init VOD FILTER', videoList);

        var categoryList = responseCat.filter((elem) => {
          if(elem.active || elem.show) {
            return elem;
          } else {
            return false;
          }
        }).sort((a, b) => a.pos - b.pos);
        //console.log('==========================************************************RESPONSE init VODCAT FILTER', categoryList);

        commit('setSelectBackDefault');
        commit('setMainMenu', categoryList);
        commit('setVodMenu', videoList);
        //dispatch('radio/prepare', null, { root: true });
        return Promise.resolve();
      } catch (err) {
        console.log("Couldn't fetch app menu because of Error: ", err);
        return Promise.reject();
      }
    },
    mainMenuGoRight({ commit, state, getters }) {
      if (state.mainMenuSelectedItemIndex < getters.getMainMenuLength - 1) {
        commit('incMainMenuIndex');
        return;
      }
      commit('setMainMenuIndex');
    },
    mainMenuGoLeft({ commit, state, getters }) {
      if (state.mainMenuSelectedItemIndex > 0) {
        commit('decMainMenuIndex');
        return;
      }
      commit('setMainMenuIndex', getters.getMainMenuLength - 1);
    },
    resetSubMenuIndex({ state, commit }, id) {
      if (!state.subMenuMap[id]) {
        console.log('NO SUBMENU FOUND FOR ID: ', id);
        commit('setSubMenu', { id });
        return;
      } else {
        commit('resetSubMenuIndex', id);
      }
    },
    openLanguageMenu() {
      router.push('/sub-menu/language');
    },
    callMainMenu({ state, commit, dispatch, getters }) {
      if (getters.getIsBackSelected) {
        //dispatch('openLanguageMenu');
        this.leave;
        //commit('leave');
        dispatch('clear');
        router.push({ name: 'Home' });
        return;
      }

      const element = getters.getMainMenuActiveItem;
      //console.log("++++++++++++++++++++++++++++++++++++++++++++++++callMainMenu", element);
      dispatch('handleItemCall', element);
    },
    handleLoggerCall(_, element) {
      // OFFENER DEFEKT, bewusst nicht geraten.
      //
      // Hier stand das Shorthand 'action' ohne passende Variable - der Aufruf
      // lief also jedes Mal in einen ReferenceError und ist nie beim
      // Socket-Server angekommen. Welchen Aktionsnamen der Server an dieser
      // Stelle erwartet, ist unklar; einen zu erfinden waere schlimmer als
      // nichts zu senden. Bis das geklaert ist wird der Fall gemeldet, statt
      // eine Ausnahme zu werfen.
      console.log('[vod] handleLoggerCall: kein Aktionsname definiert - nicht gesendet', element);
    },
    handleItemCall({ dispatch }, element) {
      const { type, url } = parseMainMenuItem(element);
      switch (type) {
        case MEDIA_TYPE.TV:
        case MEDIA_TYPE.RADIO:
        case MEDIA_TYPE.IMAGE:
        case MEDIA_TYPE.EPG:
        case MEDIA_TYPE.VOD:
        case MEDIA_TYPE.WELCOME:
        case MEDIA_TYPE.WEBSITE:
        case MEDIA_TYPE.SUBMENU:
        case MEDIA_TYPE.SUBVODMENU:
        case MEDIA_TYPE.INPUT_SOURCE:
          console.log("++++++++++++++++++++++++++++++++++++++++++++++++handleItemCall", url);
          router.push(url);//.catch(()=>{});
          break;
        case MEDIA_TYPE.BROWSER:
          // Der Browser-Start liegt im navigation-Modul, damit es nur EINE
          // Stelle gibt, die Sprache/Raum/Geraet anhaengt und den App-Wechsel
          // vermerkt.
          dispatch('navigation/openInBrowser', url, { root: true });
          break;
        default:
          dispatch(
            'notification/new',
            {
              title: 'Not supported Type: ' + element.type,
              message: 'This feature is currently not supported',
            },
            { root: true }
          );
      }
    },
    async getMainMenuItemById({ dispatch, state, getters }, id) {
      if (state.vodMenu.length < 1) {
        await dispatch('init').catch((err) => {
          console.log('COUld not init', err);
        });
      }
      const item = state.vodMenu.find((el) => el.id === id);
      if (!item)
        return Promise.resolve({
          lang: {},
        });
      return Promise.resolve(item);
    },
    async getSendMessageById({ dispatch, state, getters }, id) {
      return device.id;
      /*
      if (state.mainMenu.length < 1) {
        await dispatch('init').catch((err) => {
          console.log('COUld not init', err);
        });
      }
      const item = state.mainMenu.find((el) => el.id === id);
      if (!item)
        return Promise.resolve({
          lang: {},
        });
      return Promise.resolve(item);
      */
    },
    /*
    async fetchVodMenu({ state, dispatch, commit, getters }, { id }) {
      // console.log('getters ', getters);
      console.log('CONTEXT ', id, getters.getSubMenuById(id));
      var subMenu = await dispatch('getMainMenuItemById', id);
      if (state.subMenuMap[id]) {
        if (!state.subMenuMap[id].title) {
          const mergedMenu = { ...subMenu, ...state.subMenuMap[id] };
          commit('setSubMenu', mergedMenu);
        }
        commit('setActiveSubMenuApp', id);
        console.log('*********************************************HAS SUB MENU ALREADY', getters.getSubMenuById(id));

        return Promise.resolve();
      }
      try {
        // await dispatch('init');
        // const subMenu = await dispatch('getMainMenuItemById', id);
        //subMenu.items = await Requests.fetchSubMenu(id);
        subMenu.items = await Requests.fetchVodSubMenu(id);
        subMenu.currentIndex = 0;
        subMenu.id = id;
        console.log('VODMENU', subMenu);
        commit('setSubMenu', subMenu);
        commit('setActiveSubMenuApp', id);
      } catch (e) {
        console.log('could not fetch vod menu: ', e);
      }
      return Promise.resolve();
    },
    */
    openSubSubMenu({ commit, state }, submenu) {
      if (!state.subMenuMap[submenu.id]) {
        const newSubMenu = { ...submenu, currentIndex: 0 };
        commit('setSubMenu', newSubMenu);
      }

      router.push({
        name: 'SubMenu',
        params: {
          id: submenu.id,
        },
      });
    },
    /*
    async fetchSubMenu({ state, dispatch, commit, getters }, { id }) {
      // console.log('getters ', getters);
      // console.log('CONTEXT ', id, getters.getSubMenuById(id));
      const subMenu = await dispatch('getMainMenuItemById', id);
      if (state.subMenuMap[id]) {
        if (!state.subMenuMap[id].title) {
          const mergedMenu = { ...subMenu, ...state.subMenuMap[id] };
          commit('setSubMenu', mergedMenu);
        }
        commit('setActiveSubMenuApp', id);
        // console.log('HAS SUB MENU ALREADY', getters.getSubMenuById(id));

        return Promise.resolve();
      }
      try {
        // await dispatch('init');
        // const subMenu = await dispatch('getMainMenuItemById', id);
        subMenu.items = await Requests.fetchSubMenu(id);
        subMenu.currentIndex = 0;
        subMenu.id = id;
        console.log('SUBMENU', subMenu);
        commit('setSubMenu', subMenu);
        commit('setActiveSubMenuApp', id);
      } catch (e) {
        console.log('could not fetch sub menu: ', e);
      }
      return Promise.resolve();
    },
    */
    async fetchVodSubMenu({ state, dispatch, commit, getters, rootState }, { id }) {
      // console.log('getters ', getters);
      console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~CONTEXT ', id, getters.getSubMenuById(id));
      const subMenu = await dispatch('getMainMenuItemById', id);
/*
      if (state.subMenuMap[id]) {
        if (!state.subMenuMap[id].title) {
          const mergedMenu = { ...subMenu, ...state.subMenuMap[id] };
          commit('setSubMenu', mergedMenu);
        }
        commit('setActiveSubMenuApp', id);
        console.log('HAS SUB MENU ALREADY', getters.getSubMenuById(id));

        return Promise.resolve();
      }
*/
      try {
        // await dispatch('init');
        // const subMenu = await dispatch('getMainMenuItemById', id);
        subMenu.items = await Requests.fetchVodSubMenu(id, rootState.buildingId);
        subMenu.currentIndex = 0;
        subMenu.id = id;
        console.log('=====================================================SUBMENU', subMenu);
        commit('setSubMenu', subMenu);
        commit('setActiveSubMenuApp', id);
      } catch (e) {
        console.log('could not fetch sub menu: ', e);
      }
      return Promise.resolve();
    },
    incSubMenu({ state, commit, getters }) {
      const index = getters.getActiveSubMenuElementIndex;
      const id = state.activeSubMenuId;
      console.log('VALUE', id);
      if (index < getters.getActiveSubMenuItemsLenght - 1) {
        commit('setSubMenuIndex', { id, value: index + 1 });
        return;
      }
      commit('setSubMenuIndex', { id, value: 0 });
    },
    decSubMenu({ state, commit, getters }) {
      const index = getters.getActiveSubMenuElementIndex;
      const id = state.activeSubMenuId;

      if (index > 0) {
        commit('setSubMenuIndex', {
          id,
          value: index - 1,
        });
        return;
      }
      commit('setSubMenuIndex', {
        id,
        value: getters.getActiveSubMenuItemsLenght - 1,
      });
    },
    selectLanguage({ commit }) {
      commit('setSelectLanguage');
    },
    selectBack({ commit }) {
      commit('setSelectBack');
    },
    handleCallBackAction({ rootState }, context) {
      if (!context.src_url) return;
      try {
        if (!context.query) fetch(context.src_url);
        const searchParams = new URLSearchParams();
        if (context.query.lang) searchParams.set('lang', rootState.lang.active);
        if (context.query.deviceId)
          searchParams.set('lang', rootState.device.buildingId);
        if (context.query.room) searchParams.set('lang', rootState.device.room);
        fetch(`${context.src_url}?${searchParams.toString()}`);
      } catch (e) {
        console.log('ERROR ON CALLBACK ACTION', e);
      }
    },
    handleNextAction({ dispatch, commit, state }) {
      const { action, data } = state.nextAction;
      switch (action) {
        case 'open_source_app':
          // dispatch(
          //   'socket/handleActionCall',
          //   {
          //     action,
          //     sourceapp_id: data.sourceapp_id,
          //   },
          //   {
          //     root: true,
          //   }
          // );
          dispatch('handleOpenSourceApp', data.sourceapp_id);
          break;
        case 'callback':
          dispatch('handleCallBackAction', data);
          router.push({ name: 'Home' });
          break;
        case 'open_app':
          dispatch('handleOpenApp', data);
          break;
        case 'send_message':
          dispatch('handleSendMessage', data);
          break;
        case 'open_welcome_screen':
        default:
          dispatch(
            'notification/new',
            {
              title: 'This Action is not supported',
              message: action,
            },
            {
              root: true,
            }
          );
          router.push({ name: 'Home' });
      }
      commit('setNextAction', null);
    },
    async handleOpenApp({ dispatch }, data) {
      const app = await dispatch('getMainMenuItemById', data.app_id);
      dispatch('handleItemCall', app);
    },
    async handleSendMessage({ dispatch }, data) {
      const app = await dispatch('getSendMessageById', data);
      dispatch('handleLoggerCall', app);
    },
    handleOpenSourceApp(_, port) {
      router.push({
        name: 'InputSource',
        params: { source: 'HDMI', port: port },
      });
    },
    handleSubMenuAction({ dispatch, commit, getters, state, rootState }) {
      console.log('SUB MENU ACTION', getters.getActiveSubMenuItemType);
      if (getters.getActiveSubMenuItem.action) {
        commit('setNextAction', getters.getActiveSubMenuItem.action);
      }
      switch (getters.getActiveSubMenuItemType) {
        case 'internal':
          router.push({ path: getters.getActiveSubMenuItemActionUrl });
          break;
        case 'image':
          router.push({
            name: 'MediaPlayer',
            query: {
              type: MEDIA_TYPE.IMAGE,
              src: encodeURI(getters.getActiveSubMenuItemActionUrl),
              alt: encodeURI(this.getDescription),
            },
          });
          break;
        case 'video':
          router.push({
            name: 'MediaPlayer',
            query: {
              type: MEDIA_TYPE.VIDEO,
              src: encodeURI(getters.getActiveSubMenuItemActionUrl),
            },
          });
          break;
        case 'vod':
          router.push({
            name: 'Vod',
            query: {
              type: MEDIA_TYPE.VOD,
              src: encodeURI(getters.getActiveSubMenuItemActionUrl),
            },
          });
          break;
        case 'youtube':
        case 'website':
          router.push({
            name: 'MediaPlayer',
            query: {
              type: MEDIA_TYPE.WEBSITE,
              src: encodeURI(getters.getActiveSubMenuItemActionUrl),
            },
          });
          break;
        case 'tv':
          router.push({
            name: 'TVPlayer',
            params: getters.getActiveSubMenuItemActionUrl && {
              src: encodeURI(
                JSON.stringify(getters.getActiveSubMenuItemActionUrl)
              ),
            },
          });
          break;
        case 'language':
          dispatch('lang/select', getters.getActiveSubMenuItem, { root: true })
            .then(() => {
              router.push({ name: 'Home' });
            })
            .catch((err) => {
              console.log('Error on select lang', err);
            });
          break;
        case 'submenu':
          dispatch('openSubSubMenu', getters.getActiveSubMenuItem);
          break;
        case 'action':
          const url = assembleUrl({
            src: getters.getActiveSubMenuItemActionUrl,
            lang: rootState.lang.active,
            room: rootState.device.room,
            deviceId: rootState.device.deviceId,
          });
          dispatch(
            'notification/new',
            {
              title: 'Call action',
              message: url,
            },
            { root: true }
          );
          Requests.get(url);
          break;
        default:
          location.reload(true);
      }
    },
    async callNextActionCallback({ state, commit, rootState, getters }) {
      console.log('--> [ACTION]: callNextActionCallback');
      if (!getters.getHasNextAction) {
        console.log('[RETURN] - Has no next action applied');
        return;
      }
      const url = assembleUrl({
        src: state.nextAction,
        lang: rootState.lang.active,
        room: rootState.device.room,
        deviceId: rootState.device.deviceId,
      });
      try {
        console.log('--> Call callback url: ', url);
        Requests.get(url);
        console.log('--> Called callback url: ', url);
      } catch (err) {
        console.log('    [ERROR]: callNextActionCallback', err);
      }
      commit('setNextAction');
    },
    to({ commit, dispatch, getters }, navigateTo) {
      // if (getters.getHasNextAction) {
      //   dispatch('callNextActionCallback');
      // }
      switch (navigateTo) {
        case NAV_TYPE.BACK:
          router.go(-1);
          break;
        case NAV_TYPE.HOME:
          router.push({ name: 'Home' });
          break;
        default:
          console.log(
            '  [ERROR]: vod/to – Navigation target not supported',
            navigateTo,
            ' | Supported targets: ',
            NAV_TYPE
          );
      }
    },
    clear({ commit }) {
      commit('setLastName');
      commit('setFirstName');
      commit('setTitle');
      // commit('setSalutation');
    },
    leave({ dispatch }) {
      dispatch('clear');
      router.push({ name: 'Home' });
    },
  },
  getters: {
    getHasNextAction(state) {
      return state.nextAction !== undefined;
    },
    getTextStyles(state, getters, rootState, rootGetters) {
      //const values = this.$store.getters['customizer/getVodValues'];
      const values = rootGetters['customizer/getVodValues'];
      //const values = rootGetters['vod/getVodValues'];
      return {
        color: values.vodMessageColor,
        backgroundColor: values.vodDetailActiveBackgroundColor,
      };
    },
    getTitle(state) {
      return state.title;
    },
    getCategoryName(state) {
      return state.name;
    },
    getMainMenu(state) {
      return state.mainMenu
        .filter((e) => e.status && e.ident !== 'options')
        .sort((a, b) => (a.order > b.order ? 1 : -1));
    },
    getMainMenuLength(_, getters) {
      //return getters.getMainMenu.length;
      return _.mainMenu.length;
    },
    getMainMenuActiveItem(state, getters) {
      //return getters.getMainMenu[state.mainMenuSelectedItemIndex];
      return state.mainMenu[state.mainMenuSelectedItemIndex];
    },
    getVodMenu(state) {
      //let roomApps = store.getters['device/getRoomVodAppInDevice'];

      //return state.vodMenu;

      //return state.mainMenu
        //.filter((e) => e.status && e.ident !== 'options')
        //.sort((a, b) => (a.order > b.order ? 1 : -1));
      return state.vodMenu
        .filter((e) => e.status && e.ident !== 'options')
        .sort((a, b) => (a.pos > b.pos ? 1 : -1));
    },
    getVodMenuLength(_, getters) {
      return getters.getVodMenu.length;
    },
    getVodMenuActiveItem(state, getters) {
      return getters.getVodMenu[state.mainMenuSelectedItemIndex];
    },
    getSubMenuMap(state) {
      return state.subMenuMap;
    },
    getSubMenuById: (_, getters) => (id) => {
      if (!getters.getSubMenuMap[id]) return {};
      return getters.getSubMenuMap[id];
    },
    getActiveSubMenu(state, getters) {
      if (!state.subMenuMap[state.activeSubMenuId]) return {};
      var subMenu = state.subMenuMap[state.activeSubMenuId];
      console.log("*********************************************************************getActiveSubMenu", state);
      if(state.activeSubMenuId === 'language') {
        var subMenuTemp = subMenu.items;

        const langCustomizer = store.getters['customizer/getLanguages'];
        function setPos(e, i) {
          if(typeof langCustomizer[e.iso] == 'undefined') return;
          //console.log("+-+-+-+-+-+-+-+-+-SHOW e:", e.show, " langcustomizer[e.iso]:", langCustomizer[e.iso].show, " subMenuTemp[i]:", subMenuTemp[i].show);
          //console.log("+-+-+-+-+-+-+-+-+-POSITION e:", e.position, " langcustomizer[e.iso]:", langCustomizer[e.iso].position, " subMenuTemp[i]:", subMenuTemp[i].position);
          //console.log("+-+-+-+-+-+-+-+-+-ISO", e.iso);
          //console.log("+-+-+-+-+-+-+-+-+-I", i);
          subMenuTemp[i].position = langCustomizer[e.iso].position;
          subMenuTemp[i].pos = langCustomizer[e.iso].pos;
          subMenuTemp[i].show = langCustomizer[e.iso].show;
          //console.log("*****************subMenuTemp", subMenuTemp[i]);
        }
        subMenuTemp.forEach(setPos);
        //console.log("========================subMenuTemp", subMenuTemp);

        subMenu.items = subMenuTemp.filter((e) => (typeof(e.show) != "undefined" || false ? e.show : false) && (e.genres.includes(getters.getMainMenuActiveItem.name)));
        console.log("*********************************************************************getActiveSubMenuIF", subMenu);
        return subMenu;
      }
      console.log("*********************************************************************getActiveSubMenuBEFORE", subMenu.items);
      subMenu.items = subMenu.items.filter((e) => (typeof(e.show) != "undefined" ? e.show : false) && (e.genres.includes(getters.getMainMenuActiveItem.name))).sort((a, b) => typeof(a.pos) != "undefined" ? a.pos - b.pos : false);
      console.log("*********************************************************************getActiveSubMenuAFER", subMenu);
      return subMenu;
    },
    getActiveSubMenuItems(_, getters) {
      //console.log("*********************************************************************getActiveSubMenuItems0", getters.getMainMenuActiveItem.name);
      //console.log("*********************************************************************getActiveSubMenuItems1", getters.getActiveSubMenu.items);
      if (!getters.getActiveSubMenu.items) return [];
      return getters.getActiveSubMenu.items
      .filter((e) => e.genres.includes(getters.getMainMenuActiveItem.name))
      .sort((a, b) => typeof(a.pos) != "undefined" ? a.pos - b.pos : false);
    },
    getActiveSubMenuItemsLenght(_, getters) {
      return getters.getActiveSubMenuItems.length;
    },
    getActiveSubMenuBackground(_, getters) {
      return getters.getActiveSubMenu.backgroundUrl;
    },
    getActiveSubMenuTextColor(_, getters) {
      return getters.getActiveSubMenu.textColor;
    },
    getActiveSubMenuBackgroundColor(_, getters) {
      return getters.getActiveSubMenu.backgroundColor;
    },
    getActiveSubMenuElementIndex(_, getters) {
      return getters.getActiveSubMenu.currentIndex;
    },
    getActiveSubMenuItem(_, getters) {
      return (getters.getActiveSubMenuItems[getters.getActiveSubMenuElementIndex] || {});
    },
    getActiveSubMenuItemType(_, getters) {
      return getters.getActiveSubMenuItem.type;
    },
    getActiveSubMenuItemActionUrl(_, getters) {
      return getters.getActiveSubMenuItem.actionUrl;
    },
    getIsLanguageSelected(state) {
      return state.isLanguageSelected;
    },
    getIsBackSelected(state) {
      return state.isBackSelected;
    },
    getLangSubMenu(state) {
      return state.subMenuMap.language;
    },
    getHasNextAction(state) {
      return !!state.nextAction;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/vod.js